import React from 'react';
import { ConfigProvider, theme } from 'antd';
import '../styles/auth.css';

const authTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#f5f7ff',
    colorText: '#f5f7ff',
    colorTextSecondary: '#8e96b3',
    colorTextPlaceholder: '#5f6785',
    colorBorder: 'rgba(245, 247, 255, 0.14)',
    colorBgContainer: 'transparent',
    colorError: '#ff8a8a',
    colorSuccess: '#5ee0a0',
    colorInfo: '#8fb4ff',
    borderRadius: 10,
    controlHeight: 52,
    controlOutlineWidth: 0,
    fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 16,
  },
  components: {
    Form: { labelColor: '#c9cfe4', verticalLabelPadding: '0 0 8px' },
  },
};

// The lighting rig, drawn in a 1440x900 stage. Two beams from fixtures on the
// top edge cross in an X; the crossing sits behind the form (x=720).
const BEAMS = [
  { tone: 'cobalt', points: '300,0 350,0 1180,900 900,900' },
  { tone: 'ice', points: '1090,0 1140,0 540,900 260,900' },
];

const LightingRig = () => (
  <svg className="auth__rig" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMin slice" aria-hidden="true">
    {BEAMS.map((beam, i) => (
      <polygon key={beam.tone} className={`auth__beam auth__beam--${beam.tone}`} style={{ '--i': i }} points={beam.points} />
    ))}
    <ellipse className="auth__pool" cx="720" cy="900" rx="520" ry="70" />
    {BEAMS.map((beam) => {
      const x = Number(beam.points.split(/[ ,]/)[0]);
      return <rect key={beam.tone} className="auth__fixture" x={x - 8} y="-12" width="64" height="22" rx="5" />;
    })}
  </svg>
);

/**
 * Shared frame for the sign-in screens: a dark house with a lighting rig whose
 * beams converge on the form. Logo top-left, headline, a line naming
 * Festivals Portal, the form, and a footer line.
 */
const AuthLayout = ({ title, subtitle, footer, children }) => (
  <ConfigProvider theme={authTheme}>
    <div className="auth">
      <LightingRig />

      <header className="auth__top">
        <img className="auth__logo" src="/images/FM_Logo.png" alt="Festivals Malta" />
      </header>

      <main className="auth__main">
        <div className="auth__form">
          <h1 className="auth__title">{title}</h1>
          {subtitle && <p className="auth__subtitle">{subtitle}</p>}
          {children}
        </div>
      </main>

      {footer && <footer className="auth__footer">{footer}</footer>}
    </div>
  </ConfigProvider>
);

export default AuthLayout;
